import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import $ from 'jquery';
import 'popper.js';
import 'bootstrap';
import BootstrapVue from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.min.css';
import './css/fontawesome/css/all.min.css';
// import "./registerServiceWorker";

// Dev mode
if (location.hostname.match(/(lole.kings.kucits.ca)|(tomo.kings.kucits.ca)/gi)) {
  Vue.config.devtools = true
  Vue.config.productionTip = false
}
Vue.use(BootstrapVue)

new Vue({
  router,
  render: h => h(App)
}).$mount("#app");